import React, { useState } from 'react'
import config from '../../config.json'
import Login from './Login'
import RedefinirSenha from './RedefinirSenha'
import fundoLogin from '../../css/fundoLogin.svg'
import {
  Button,
  Container,
  Grid,
  makeStyles,
  Paper,
  Typography,
} from '@material-ui/core'
import { NovaConta } from './NovaConta'
import translations from '../../translations'

const useStyles = makeStyles((theme) => ({
  paper: {
    boxShadow: `${theme.shadows[3]}, 0px -4px 1px -2px ${theme.palette.primary[theme.palette.type === 'dark' ? 'dark' : 'main']}`,
    maxWidth: 500,
    width: 'calc(100% - 64px)',
  },
  title: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    margin: 15,
  },
  title1: {
    fontWeight: '800',
  },
  title2: {
    fontWeight: '500',
  },
  container: {
    padding: 10,
  },
  linkButton: {
    textTransform: 'none',
    display: 'block',
  },
  span: {
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'center',
    textAlign: 'justify',
  },
}))

const Index = () => {
  const t = translations[navigator.language.split('-')[0].toUpperCase()] || translations['PT'];
  const classes = useStyles()
  const [tela, setTela] = useState('login')
  const [esqueciSenha, setEsqueciSenha] = useState(false)

  const esqueciMinhaSenha = () => setEsqueciSenha(true)
  const voltarTelaLogin = () => setEsqueciSenha(false)
  const novoCadastro = () => setTela('cadastro')
  const [telaValidaToken, setTelaValidaToken] = useState({
    open: false,
    idUsuario: '',
  })

  return (
    <div
      style={{
        backgroundImage: `url(${fundoLogin})`,
        width: '100%',
        height: '100vh',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
      }}
    >
      <div className="flex h-screen w-screen items-center justify-center">
        <Paper
          className="max-w-[500px] shadow-lg"
          style={{ width: 'calc(100% - 64px)' }}
        >
          <span
            color="primary"
            className="m-[12px] flex items-center justify-center text-4xl font-bold text-default"
          >
            {config.titulo}
          </span>
          <hr />
          <Container className={classes.container}>
            <Grid container spacing={2}>
              {esqueciSenha ? (
                <>
                  <Grid item xs={12}>
                    <span className="flex items-baseline justify-center text-justify">
                      {t.msgEsqueceuSenha}
                    </span>
                  </Grid>
                  <RedefinirSenha voltarTelaLogin={voltarTelaLogin} />
                  <Grid item xs={12}>
                    <Button
                      color="primary"
                      className={classes.linkButton}
                      onClick={voltarTelaLogin}
                    >
                      {t.login}
                    </Button>
                  </Grid>
                </>
              ) : (
                <>
                  {tela === 'login' ? (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="body1" className={classes.span}>
                          <span></span>
                        </Typography>
                      </Grid>
                      <Login
                        setTela={setTela}
                        setTelaValidaToken={setTelaValidaToken}
                        telaValidaToken={telaValidaToken}
                      />
                      <div className="flex w-full justify-between p-2">
                        <button
                          className="block bg-transparent p-1 text-sm text-primary-main hover:shadow-md"
                          onClick={esqueciMinhaSenha}
                        >
                          {t.esqueciSenha}
                        </button>
                        <button
                          onClick={novoCadastro}
                          className="block bg-white p-1 text-sm text-primary-main hover:shadow-md"
                        >
                          {t.registrar}
                        </button>
                      </div>
                    </>
                  ) : (
                    <>
                      <Grid item xs={12}>
                        <Typography variant="body1" className={classes.span}>
                          {t.registrar}
                        </Typography>
                      </Grid>
                      <NovaConta
                        setTela={setTela}
                        setTelaValidaToken={setTelaValidaToken}
                        telaValidaToken={telaValidaToken}
                      />
                      <div className="flex w-full justify-between p-2">
                        <button
                          onClick={() => setTela('login')}
                          className="block bg-white p-1 text-sm text-primary-main hover:shadow-md"
                        >
                          {t.jaTemConta}
                        </button>
                      </div>
                    </>
                  )}
                </>
              )}
            </Grid>
          </Container>
        </Paper>
      </div>
    </div>
  )
}

export default Index
